import type { NursingHomeIdType } from '@app/icare/entities/nursingHome/schema/NursingHome'
import { ContactPersonTable } from '@app/icare/routes/_app/apotheken/-components/ContactPersonTable'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/pflegeheime/$id/contact-persons')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ContactPersonTable ownerId={Route.useParams().id as NursingHomeIdType} />
}
